import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';

class Breadcrums extends React.Component {
  render() {
    // for each item in props create a breadcrum

    if (!this.props.items) {
      return null;
    }
    return (
      <div className="breadcrums row">
        <div className="col-8">
          {this.props.items.map((d, idx) => {
            if (d.text === 'STUDY HOME') {
              return (
                <Link to={d.to} key={idx}>
                  <i
                    className="icon-chevron_left"
                    data-test="study-home-breadcrums"
                  />{' '}
                  {d.text}
                </Link>
              );
            }

            return (
              <Link to={d.to} key={idx}>
                <i className="icon-chevron_left" /> {d.text}
              </Link>
            );
          })}
        </div>
        {this.props.resetChapter ? (
          <div className="col-4 d-flex justify-content-end">
            <span id="chapter-in-review" className="review__textbox">
              Reviewing questions
            </span>
            <UncontrolledTooltip placement="bottom" target="chapter-in-review">
              Correct answers won&apos;t earn points during review phase.
            </UncontrolledTooltip>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Breadcrums;
